import { SkeletonPlaceholder } from '@carbon/react';
import styles from './skeleton-list.module.scss';
interface SkeletonListProps {
  title: string;
  rows: number;
}

export const SkeletonList = ({ title, rows }: SkeletonListProps) => {
  return (
    <div className={styles.container}>
      <h4 className={styles.title}>{title}</h4>
      {[...Array(rows)].map((_, index) => (
        <SkeletonPlaceholder key={index} className={styles.skeletonItem} />
      ))}
    </div>
  );
};
